import { render, staticRenderFns } from "./ChangelogDetail.vue?vue&type=template&id=ecfd5798&scoped=true&lang=pug&"
import script from "./ChangelogDetail.vue?vue&type=script&lang=js&"
export * from "./ChangelogDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogDetail.vue?vue&type=style&index=0&id=ecfd5798&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfd5798",
  null
  
)

export default component.exports